import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { PARAM_FILTER, PARAM_SORT, EmptyPage } from '../../../common'
import { ParamOption } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import { TradeHistoryDone } from './TradeHistoryDone'
import { TradeHistoryYet } from './TradeHistoryYet'

type Props = {
  productId: number
}

export const TradeHistory: React.FC<Props> = ({ productId }) => {
  const { authStore, marketStore } = useContext(StoresContext)
  const [filterType, setFilterType] = useState<PARAM_FILTER>(PARAM_FILTER.DONE)
  const [sortType, setSortType] = useState<PARAM_SORT>(PARAM_SORT.LATEST)
  const donePagingStore = marketStore.tradeHistoryDonePagingStore
  const yetPagingStore = marketStore.tradeHistoryYetPagingStore

  useEffect(() => {
    const newSort = PARAM_SORT[sortType as unknown as keyof typeof PARAM_SORT] as unknown as string[]
    if (filterType === PARAM_FILTER.DONE) {
      donePagingStore.load(
        {
          param: { productId: Number(productId) },
          data: {
            sort: newSort,
          },
        },
        true,
      )
    } else {
      yetPagingStore.load(
        {
          param: { productId: Number(productId) },
          data: {
            sort: newSort,
          },
        },
        true,
      )
    }
  }, [filterType, sortType])

  const filterList = [
    {
      type: PARAM_FILTER.DONE,
      title: '체결',
    },
    {
      type: PARAM_FILTER.YET,
      title: '미체결',
    },
  ]

  const sortList = [
    {
      type: 'DESC',
      title: '최근 거래순',
    },
    {
      type: 'ASC',
      title: '오래된 거래순',
    },
  ]

  return (
    <>
      <ParamOption
        filterData={{
          filterList: filterList,
          filterType: filterType,
          setFilterType: setFilterType,
        }}
        sortData={{
          sortList: sortList,
          setSortType: setSortType,
        }}
      />
      <ContentsContainer>
        {authStore.userInfo == null ? (
          <EmptyPage icon={'alert-circle-outline'} content={'로그인 후 이용 가능합니다.'} isSignIn={true} />
        ) : (
          <>
            {filterType === PARAM_FILTER.DONE && <TradeHistoryDone productId={productId} />}
            {filterType === PARAM_FILTER.YET && <TradeHistoryYet productId={productId} />}
          </>
        )}
      </ContentsContainer>
    </>
  )
}

const ContentsContainer = styled.div`
  padding: 0 20px;
`
